var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComparison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.21,2.61c0.1-0.1,0.09-0.26,0-0.35l-0.84-0.83c-0.1-0.1-0.26-0.09-0.35,0l-2.85,2.91l-1.33-1.36 c-0.1-0.1-0.25-0.1-0.35,0l-0.84,0.83c-0.1,0.1-0.1,0.25,0,0.35l1.35,1.38l0.58,0.6l0.58,0.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13,26.13h-7.5c-1.01,0-1.84-0.83-1.84-1.84V12.94c0-1.01,0.83-1.84,1.84-1.84h7.5c1.01,0,1.84,0.83,1.84,1.84v11.36 C10.97,25.31,10.14,26.13,9.13,26.13z M1.63,12.78c-0.09,0-0.16,0.07-0.16,0.16v11.36c0,0.09,0.07,0.16,0.16,0.16h7.5 c0.09,0,0.16-0.07,0.16-0.16V12.94c0-0.09-0.07-0.16-0.16-0.16H1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,25.99h-7.5c-1.01,0-1.84-0.83-1.84-1.84V9.65c0-1.01,0.83-1.84,1.84-1.84h7.5c1.01,0,1.84,0.83,1.84,1.84v14.5 C26.02,25.16,25.19,25.99,24.18,25.99z M16.68,9.49c-0.09,0-0.16,0.07-0.16,0.16v14.5c0,0.09,0.07,0.16,0.16,0.16h7.5 c0.09,0,0.16-0.07,0.16-0.16V9.65c0-0.09-0.07-0.16-0.16-0.16H16.68z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.89,2.53L7.06,1.7c-0.1-0.1-0.26-0.1-0.35,0L5.38,3.01L4.07,1.68c-0.1-0.1-0.26-0.1-0.35,0L2.88,2.51 c-0.1,0.1-0.1,0.26,0,0.35l1.31,1.32L2.87,5.5c-0.1,0.1-0.1,0.26,0,0.35l0.83,0.84c0.1,0.1,0.26,0.1,0.35,0l1.32-1.31L6.68,6.7 c0.1,0.1,0.26,0.1,0.35,0l0.84-0.83c0.1-0.1,0.1-0.26,0-0.35L6.56,4.2l1.32-1.31C7.98,2.79,7.98,2.63,7.89,2.53z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparison);
export default __webpack_public_path__ + "static/media/Comparison.12c853affd430bf68cee30442db82eae.svg";
export { ForwardRef as ReactComponent };